import React, {useEffect} from 'react';
import {InsuranceContext} from "./InsuranceContext";
import ObjectDataHolder from "../Hooks/ObjectDataHolder";
import {getInitialData} from "./functions";
import {useLocation} from "react-router-dom";
import MainForm from "./InsuranceForm/MainForm";
import {initialFormObject} from "./formObject";


const Insurance = () => {
  const initial:{} = {

    initialData: {
      agentRLookUpId: -1,
      bankRLookUpId: -1,
      contractRLookUpId: -1,
      customerRLookUpId: -1,
      fundRLookUpId: -1,
      insuranceTypeRLookUpId: -1,
      organizationRLookUpId: -1,
      tax: -1,
    }, //
    selectBoxData: {}, //
    sendData: {//

      mode: "add",//
      id: "",//
      overallInfo: {
        'insuranceNumber': "", //
        'contractType': "", //
        'customerId': "", //
        'organizationId': "", //
        'contractId': "", //
        'insuranceTypeId': "", //
        'insurancePrice': "", //
        'paymentType': "", //
        'plate': "", //

        ////
        //  ما اینجا یه وابستگی داریم اگه نوع قرار داد سازمانی بود
        // باید دو تا آرلوکاپ دیده بشن آرلوکاپ مشتری و آرلوکاپ  قرار داد
        //و آرلوکاپ قرار داد یه وابستگی به نتیجه ی جواب آرلوکاپ انتخاب سازمان داره
        // که اینجا دارم اون وابستگی رو توی کلید  ذخیره میکنم

        depContractRLookup: "",//
        // در صورتی که نتیجه ی آرلوکاپ مشتری  اطلاعات سازمانب اومد باید آرلوکاپ قرار داد ظاهر بشه. و اینجا مشخصش میکنم
        showContractRLookUp: false,

      },


      iranInsurance: {
        'firstInstallmentDate': "", //
        'depositBankId': "", //


      }, internalResources: {
        'firstInternalDate': "", //
        'dayCount': "", //
        'internalInstallmentCount': "", //

      },


      financial: {
        'hasAgent': "", //
        'agentId': "", //
        'prePayment': "", //
        'receiveType': "", //
        'fundId': "", //
        'bankId': "", //
        'addedValue': "", //
      },


      furtherInfo: {
        'description': "",//
      }, //

    }
  }

  const myLocation = useLocation()


  const [myData, setMyData] = ObjectDataHolder({...initial});

  useEffect(() => {

    const initialDataHandler = async () => {
      const initialData = await getInitialData('/?request=initialData')
      const selectBoxData = await getInitialData('/?request=selectBoxOptions')
      const id = myLocation?.state?.id

      if (id) {
        const sendData = await getInitialData('/?request=insuranceSubmittedData&insuranceId=' + id)
        setMyData({sendData, initialData, selectBoxData})

      } else {
        setMyData({initialData, selectBoxData})

      }
    }


    void initialDataHandler();


    // return ()=>{
    //
    //   setMyData({sendData:{//
    //
    //       mode: "add",//
    //       id: "",//
    //       overallInfo: {
    //         'insuranceNumber': "", //
    //         'contractType': "", //
    //         'customerId': "", //
    //         'organizationId': "", //
    //         'contractId': "", //
    //         'insuranceTypeId': "", //
    //         'insurancePrice': "", //
    //         'paymentType': "", //
    //         'plate': "", //
    //
    //         ////
    //         //  ما اینجا یه وابستگی داریم اگه نوع قرار داد سازمانی بود
    //         // باید دو تا آرلوکاپ دیده بشن آرلوکاپ مشتری و آرلوکاپ  قرار داد
    //         //و آرلوکاپ قرار داد یه وابستگی به نتیجه ی جواب آرلوکاپ انتخاب سازمان داره
    //         // که اینجا دارم اون وابستگی رو توی کلید  ذخیره میکنم
    //
    //         depContractRLookup: "",//
    //         // در صورتی که نتیجه ی آرلوکاپ مشتری  اطلاعات سازمانب اومد باید آرلوکاپ قرار داد ظاهر بشه. و اینجا مشخصش میکنم
    //         showContractRLookUp: false,
    //
    //       },
    //
    //
    //       iranInsurance: {
    //         'firstInstallmentDate': "", //
    //         'depositBankId': "", //
    //
    //
    //       }, internalResources: {
    //         'firstInternalDate': "", //
    //         'dayCount': "", //
    //         'internalInstallmentCount': "", //
    //
    //       },
    //
    //
    //       financial: {
    //         'hasAgent': "", //
    //         'agentId': "", //
    //         'prePayment': "", //
    //         'receiveType': "", //
    //         'fundId': "", //
    //         'bankId': "", //
    //         'addedValue': "", //
    //       },
    //
    //
    //       furtherInfo: {
    //         'description': "",//
    //       }, //
    //
    //     }})
    // }

  }, []);


  return <InsuranceContext.Provider value={{myData, setMyData}}>
    <MainForm/>
  </InsuranceContext.Provider>
};

export default Insurance;
